import React from "react";
import { SbomInsight } from "../../../types";
import styles from "./insights.module.scss";

type SbomChartProps<T extends string> = {
  sbomInsights: SbomInsight<T>;
};

function SbomChart<T extends string>({
  sbomInsights,
}: SbomChartProps<T>): React.JSX.Element {
  const sortedSbomInsights = sbomInsights.toSorted(
    (first, second) => second.count - first.count,
  );
  const maxCount = sbomInsights[0]?.count ?? 0;

  return (
    <div className={styles["sbom-bar-chart"]}>
      {sortedSbomInsights.map((item) => (
        <React.Fragment key={item.label}>
          <div className={styles.label} title={item.label}>
            {item.label}
          </div>
          <div
            style={{
              width: `${(item.count * 100) / maxCount}%`,
            }}
            className={styles["bar-content"]}
          />
          <div className={styles.count}>{item.count.toLocaleString()}</div>
        </React.Fragment>
      ))}
    </div>
  );
}

export default SbomChart;
